<template>
  <header :class="['main-header', { white: this.$root.headeriswhite }]">
    <transition name="fade">
      <div
        class="preloader"
        v-if="!$root.dataReady && !this.$root.headeriswhite"
      ></div>
    </transition>
    <div class="element">
      <router-link v-if="headerOptionsReady" :class="['logo']" tag="a" to="/">
        <img
          v-if="this.$root.headeriswhite"
          :src="headerOptions.header_logo_white.url"
          alt="Weber Shandwick"
        />
        <img
          v-else
          :src="headerOptions.header_logo_black.url"
          alt="Weber Shandwick"
        />
      </router-link>
    </div>
    <div class="element">
      <nav
        class="menu"
        :class="{ open: $root.menuOpen }"
        v-if="$root.dataReady"
      >
        <ul>
          <li v-for="(menu, index) in menus" :key="index" active-class="active">
            <a :href="menu.url">{{ menu.title }}</a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="element" v-if="$root.dataReady">
      <a
        v-if="header.phone_number"
        :href="'tel:' + header.phone_number"
        class="phone"
      >
        <svg
          width="42px"
          height="42px"
          viewBox="0 0 42 42"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Final-round"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="3-offer" transform="translate(-1225.000000, -48.000000)">
              <g id="Group-15" transform="translate(30.000000, 30.000000)">
                <path
                  d="M1216,18 C1227.59798,18 1237,27.4020203 1237,39 C1237,50.5979797 1227.59798,60 1216,60 C1204.40202,60 1195,50.5979797 1195,39 C1195,27.4020203 1204.40202,18 1216,18 Z M1211.28743,31.3123479 C1211.03508,30.9599853 1210.54204,30.8859481 1210.23483,31.1923801 L1210.23483,31.1923801 L1208.0048,33.42241 C1208.0048,33.42241 1207.66536,37.2819453 1212.6932,42.308253 C1217.72103,47.3338753 1221.58106,46.9952233 1221.58106,46.9952233 L1221.58106,46.9952233 L1223.81176,44.7651934 C1224.11897,44.4580759 1224.03257,43.9528401 1223.6801,43.700565 L1223.6801,43.700565 L1221.05921,41.8304384 C1220.70674,41.5774778 1220.16706,41.6234083 1219.85985,41.9298403 L1219.85985,41.9298403 L1218.23465,43.554547 C1217.10387,42.7449358 1215.88394,41.752288 1214.56595,40.4353844 C1213.24865,39.1177953 1212.2557,37.8975514 1211.44584,36.7684831 L1211.44584,36.7684831 L1213.07104,35.1430909 C1213.37825,34.8359733 1213.44751,34.3204546 1213.19447,33.9687776 L1213.19447,33.9687776 Z"
                  id="Oval-2"
                />
              </g>
            </g>
          </g>
        </svg>
        <span>{{ header.phone_number }}</span>
      </a>
      <div
        class="burger"
        v-on:click="toggleMenu"
        :class="{ close: $root.menuOpen }"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "main-header",
  props: ["blockdata"],
  data() {
    return {
      isOpen: false,
      header: null,
      headerReady: false,
      headerOptions: null,
      headerOptionsReady: false,
      mapsRepeater: [],
      itemIndex: 0,
      menus: [],
    };
  },
  created: function () {},
  mounted: function () {
    this.fetchData();
  },
  methods: {
    handleButton: function (index) {
      this.itemIndex = index;
    },
    toggleMenu: function () {
      this.$root.menuOpen = !this.$root.menuOpen;
    },
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/page_components?slug=header",

        function (response) {
          self.header = response[0].acf;
          self.headerReady = true;
        }
      )
        .done(function () {})
        .fail(function () {});

      $.get(
        self.$root.apiUrl + "wp-json/acf/v3/options/options",
        function (response) {
          self.headerOptions = response.acf;
          self.headerOptionsReady = true;
        }
      )
        .done(function () {})
        .fail(function () {});

      $.get(
        self.$root.apiUrl + "wp-json/menus/v1/menus/header",
        function (response) {
          self.menus = response.items;
          self.headerReady = true;
          // console.log("response", response.items);
        }
      )
        .done(function () {})
        .fail(function () {});
    },
  },
  watch: {
    $route: function () {
      this.$root.menuOpen = false;
    },
  },
};
</script>
<style lang="scss" scope>
.fade-enter {
  opacity: 1;
}
.fade-enter-active {
  opacity: 1;
}
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 1s;
  opacity: 0;
}
.fade-leave {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// MainHeader.vue?3249693d